import * as React from 'react';
import { useFiltersContext } from '../contexts/filters';
import { IPost } from '../types';
import Modal from './Modal';
import BeforeAfterModal from './cards/BeforeAfterModal';

interface IProps {
	posts: Array<IPost>;
}

const PostsModal = ({ posts }: IProps) => {
	const { modalOpen, modalPostDisplayed, setModalOpen, setModalPostDisplayed } =
		useFiltersContext();

	let indexedPosts: Array<number> = [];

	const handlePostChange = (next: boolean) => {
		if (setModalPostDisplayed) {
			const index = indexedPosts.indexOf(modalPostDisplayed);
			let newIndex = index - 1;
			if (next) {
				newIndex = index + 1;
			}
			if (newIndex < 0) {
				newIndex = indexedPosts.length - 1;
			}
			if (newIndex > indexedPosts.length - 1) {
				newIndex = 0;
			}
			setModalPostDisplayed(indexedPosts[newIndex]);
		}
	};

	if (posts.length && setModalOpen && modalOpen) {
		const displayPost = posts.filter((post) => post.ID === modalPostDisplayed);
		indexedPosts = posts.map((post) => post.ID);
		return (
			<Modal isOpen={modalOpen} onClose={() => setModalOpen(false)}>
				{displayPost[0] && (
					<BeforeAfterModal post={displayPost[0]} key={displayPost[0].ID} />
				)}
				{setModalPostDisplayed && (
					<footer className="pfa-modal__footer">
						<div className="pfa-modal__footer-left">
							<button
								className="btn btn-tertiary btn-black btn-modal"
								aria-label="Consultation Modal"
								aria-controls="consultation-modal"
								aria-expanded="false"
								onClick={() => setModalOpen(false)}
							>
								Free Consultation
							</button>
						</div>
						<div className="pfa-modal__footer-right">
							<button
								className="btn btn-tertiary btn-black btn-display-desktop"
								onClick={() => handlePostChange(true)}
							>
								Next B&A
							</button>
							<button
								className="pfa-modal__arrow pfa-modal__arrow--prev"
								onClick={() => handlePostChange(false)}
							>
								<i className="icon-arrow-left"></i>
								<span className="sr-only">Previous</span>
							</button>
							<button
								className="pfa-modal__arrow pfa-modal__arrow--next"
								onClick={() => handlePostChange(true)}
							>
								<i className="icon-arrow-right"></i>
								<span className="sr-only">Next</span>
							</button>
						</div>
					</footer>
				)}
			</Modal>
		);
	}

	return <></>;
};

PostsModal.displayName = 'PostsModal';

export default PostsModal;
